const u = up.util;
const DESCENDANT_SELECTOR = /^([^ >+(]+) (.+)$/;
up.FragmentFinder = class FragmentFinder {
    constructor(options) {
        var _a;
        this._options = options;
        this._origin = options.origin;
        this._selector = options.selector;
        this._document = options.document || window.document;
        this._match = (_a = options.match) !== null && _a !== void 0 ? _a : up.fragment.config.match;
        this._preferOldElements = options.preferOldElements;
    }
    find() {
        return this._findInPreferredElements() || this._findInRegion() || this._findFirst();
    }
    _findInPreferredElements() {
        if (this._preferOldElements) {
            return this._preferOldElements.find((preferOldElement) => this._document.contains(preferOldElement) && up.fragment.matches(preferOldElement, this._selector));
        }
    }
    _findInRegion() {
        var _a;
        if (this._match === 'region' && !up.fragment.containsMainPseudo(this._selector) && ((_a = this._origin) === null || _a === void 0 ? void 0 : _a.isConnected)) {
            return this._findClosest() || this._findDescendantInRegion();
        }
    }
    _findClosest() {
        return up.fragment.closest(this._origin, this._selector, this._options);
    }
    _findDescendantInRegion() {
        let simpleSelectors = up.fragment.splitTarget(this._selector);
        return u.findResult(simpleSelectors, (simpleSelector) => {
            let parts = simpleSelector.match(DESCENDANT_SELECTOR);
            if (parts) {
                let parent = up.fragment.closest(this._origin, parts[1], this._options);
                if (parent) {
                    return up.fragment.getFirstDescendant(parent, parts[2]);
                }
            }
        });
    }
    _findFirst() {
        return up.fragment.getFirstDescendant(this._document, this._selector, this._options);
    }
};
